import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { getAccount } from '@modules/auth/components/lib/account';
import { StoreState } from '@src/meta/types/store';
import { setAccount } from '@src/actions/accounts';

type PropsFromState = {
  accountId: string;
};

type PropsFromDispatch = {
  setAccount: any;
};

type Props = PropsFromState & PropsFromDispatch;

function AccountRefresher(props: Props) {
  useEffect(() => {
    async function refreshAccounts() {
      const accounts = await getAccount(props.accountId);
      props.setAccount(accounts);
    }
    refreshAccounts();
  }, []);
  return null;
}

const mapDispatchToProps: PropsFromDispatch = {
  setAccount,
};

function mapStateToProps(state: StoreState): PropsFromState {
  return {
    accountId: state.account.account.id,
  };
}

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(AccountRefresher);
